import { StatusBar } from '@capacitor/status-bar';
import { checkInCapacitor } from './utils';
import { codePush } from 'cap-codepush';
if (checkInCapacitor()) {
  StatusBar?.hide();

  codePush.notifyApplicationReady();
}
